import React, { useEffect, useState } from "react";
import { NODE_ENV } from "common/env";
import { Button } from "../../Common/Button";
import { Icon } from "../../Common/Icons/LucideIcons";
import { BannerContainer, BannerTextWrapper } from "./__styles__/StagingBanner";

export const StagingBanner = () => {
  const [showBanner, setShowBanner] = useState<boolean>(true);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--staging-banner-height",
      showBanner ? "30px" : "0px",
    );
  }, [showBanner]);

  return showBanner ?
      <BannerContainer environment={NODE_ENV}>
        <BannerTextWrapper>
          {NODE_ENV === "production" ?
            "On Nov 22nd, 10 pm EST, Forerunner will be temporarily unavailable due to scheduled maintenance for approximately 4 hours to maintain top performance and reliability. Thank you for your understanding!"
          : `You're currently viewing the Forerunner ${NODE_ENV} environment`}
        </BannerTextWrapper>
        <Button
          onClick={() => setShowBanner(false)}
          styleVariant={"ghost"}
          aria-label="Close Banner"
        >
          <Icon iconName="x" color="contentPrimaryInverted" size={16} />
        </Button>
      </BannerContainer>
    : null;
};
